import React, { useState, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import './style.css'

export default function NavData({ customTitles = {}, customPaths = {} }) {
  const [data, setData] = useState([]);

  const fetchData = () => {
    axios.post(`${SERVER_PATH}get/all_products.php`, {}).then((res) => {
      setData(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const herbalProducts = HerbalProducts();

  function HerbalProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "herbal")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const gardenProducts = GardenProducts();

  function GardenProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "garden")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const yogaProducts = YogaProducts();

  function YogaProducts() {
    const arr = [];
    arr.push({
      productId: 66,
      productName: "Ultimate health Challenge",
    });
    return arr;
  }

  const spices = Spices();

  function Spices() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "wellness")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const foodProducts = FoodProducts();

  function FoodProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "food")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const dropDown = [
    {
      title: customTitles.herbal || "Herbal Products",
      dropDownTitle: herbalProducts,
    },
    {
      title: customTitles.wellness || "Health And Wellness",
      dropDownTitle: spices,
    },
  ];

  return (
    <>
      {dropDown.map((data, index) => (
        <li className="nav-item" key={index + "dropdown"} >
          <NavDropdown
          
            title={data.title}
            id="basic-nav-dropdown"
            className="custom-dropdown" // Add custom class here
          >
            {data.dropDownTitle.map((d, i) => (
              <NavDropdown.Item
                style={{ fontWeight: "400" }}
                as={Link}
                // to={`/${data.title == "Health And Wellness" ? "yoga" : "product"}/${d.productId}`}
                to={`/product/${d.productId}`}
                key={i + "dropdownItem"}
              >
                {d.productName}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </li>
      ))}
    </>
  );
}

